export default __webpack_public_path__ + "static/media/designIcon.910023dc.svg";